// tslint:disable:jsx-no-lambda
// tslint:disable:jsx-no-bind
// tslint:disable:jsx-no-string-ref
import * as React from 'react';
import { inject } from 'mobx-react';
import 'cropperjs/dist/cropper.css';
import { WithAriticleEdit } from '../../components/HOC/EditArticleHOC/EditArticleHOC';
import { WithBaiduMediaUpload } from '../../components/HOC/BaiduMediaUpload';
import ArticleEdit from '../../components/ArticleEdit';
import * as classnames from 'classnames';
import { Button } from 'antd';
import moment from 'moment';
import tool from '@util/tool';

import './index.scss';
import toast from '@util/toast/toast';
// @WithMediaUpload(inject('store'))
@WithBaiduMediaUpload(inject('store'))
@WithAriticleEdit(inject('store'))
export default class CreateArticleMain extends React.Component<any, any> {
    public checkSaveDraftTimer: any;
    public iframeAddr: string;
    constructor(props) {
        super(props);
        this.state = {
            hasScrollBottom: false,
            previewActive: 0,
            userName: null
        };
    }
    // 添加延迟事件监听，为了让图片加描述的内容及时响应上
    public addTimeoutEvent = (fn, haslink?) => {
        setTimeout(() => {
            (haslink && fn(haslink)) || fn();
        }, 150);
    };
    public showPreview = () => {
        this.addTimeoutEvent(this.props.showPreview);
        this.saveParamDraft(); // 为了配合得到productid,获取手机预览二维码
    };
    // 保存草稿加参数
    public saveParamDraft = (bool?) => {
        this.props.checkSaveDraft(bool);
    };
    public checkSaveDraft = bool => {
        this.addTimeoutEvent(this.saveParamDraft, bool);
    };
    public showTimeing = () => {
        this.props.showTimeing();
    };
    // 创建文章及时清除定时器
    public createArticleClearTimer = () => {
        this.props.checkCreateArticel(() => {
            clearInterval(this.checkSaveDraftTimer);
        });
    };
    public checkCreateArticel = () => {
        this.props.checkSaveDraft(false);
        this.addTimeoutEvent(this.createArticleClearTimer);
    };
    public closeCrop = e => {
        this.props.closeCrop(e);
    };
    public timeOnchange = () => {
        this.props.timeOnchange();
    };
    public getPublicTime = e => {
        this.props.getPublicTime(e);
    };
    /**
     * previewSwitch
     */
    public previewSwitch = num => {
        this.setState({
            previewActive: num
        });
    };
    public componentWillMount() {
        const Env = window['serverEnv'] || window['localEnv'];
        switch (Env) {
            case 'dev':
                this.iframeAddr = 'http://www-dev.lixiang.com';
                break;
            case 'test':
                this.iframeAddr = 'https://www-test.lixiang.com';
                break;
            case 'ontest':
                this.iframeAddr = 'https://www-on-test.lixiang.com';
                break;
            case 'prod':
                this.iframeAddr = 'https://www.lixiang.com';
                break;
            default:
                toast.error('缺少iframe环境变量');
                break;
        }

        const userInfo = JSON.parse(localStorage.getItem('USERINFO'));
        this.setState({
            userName:
                (userInfo && userInfo.nickname && userInfo.nickname) || '未知',
            avatar: (userInfo && userInfo.avatar && userInfo.avatar) || ''
        });
    }
    public componentDidMount() {
        this.checkSaveDraftTimer = setInterval(() => {
            this.props.checkSaveDraft();
        }, 5000);

        document.addEventListener('visibilitychange', () => {
            // 页面变为不可见时触发
            if (document.visibilityState === 'hidden') {
                clearInterval(this.checkSaveDraftTimer);
            }
            // 页面变为可见时触发
            if (document.visibilityState === 'visible') {
                this.checkSaveDraftTimer = setInterval(() => {
                    this.props.checkSaveDraft();
                }, 5000);
            }
        });

        window.onscroll = () => {
            if (
                tool.getScrollTop() + tool.getWindowHeight() >
                tool.getScrollHeight() - 80
            ) {
                if (this.state.hasScrollBottom) {
                    this.setState({
                        hasScrollBottom: false
                    });
                }
            } else {
                if (!this.state.hasScrollBottom) {
                    this.setState({
                        hasScrollBottom: true
                    });
                }
            }
        };
    }
    public componentWillUnmount() {
        clearInterval(this.checkSaveDraftTimer);
    }
    public render() {
        const {
            articleQrcode,
            errorStatus,
            errorContent,
            previewBoxHasHide,
            timingPublicBoxHasHide,
            getChildRefs,
            cropImg,
            articleTitle,
            previewContent
        } = this.props;
        const { hasScrollBottom, previewActive, userName, avatar } = this.state;
        return (
            <div className="CreateArticleMainBox">
                <ArticleEdit {...this.props} />
                <div className="button-box">
                    <div
                        className={classnames('to-bottom-box', {
                            fixed: hasScrollBottom
                        })}>
                        <Button
                            type="primary"
                            onClick={() => this.showPreview()}>
                            预览手机版
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => this.checkSaveDraft(true)}>
                            保存草稿
                        </Button>
                        {/* <Button
                            type="primary"
                            onClick={() => this.showTimeing()}>
                            定时发布
                        </Button> */}
                        <Button
                            type="primary"
                            onClick={() => this.checkCreateArticel()}>
                            发布文章
                        </Button>
                    </div>
                </div>
                <div
                    className={classnames('timingPublicBox', {
                        hide: timingPublicBoxHasHide
                    })}>
                    <div className="selectTimeBox">
                        <div className="timingBoxHeader">
                            <h4>定时发布</h4>
                            <span
                                className="closeBtn"
                                onClick={e => this.closeCrop(e)}>
                                <img
                                    src={require('../../assets/images/commonImg/closeBtn.png')}
                                    alt=""
                                />
                            </span>
                        </div>
                        <div className="timingConBox">
                            <span>请选择发布时间</span>
                            <div className="selectBox">
                                <select
                                    name=""
                                    id="timeDay"
                                    ref={timeDay =>
                                        getChildRefs({
                                            name: 'timeDay',
                                            value: timeDay
                                        })
                                    }
                                    onChange={e => this.timeOnchange()}>
                                    {this.props.timeDay &&
                                        this.props.timeDay.map((item, idx) => {
                                            return (
                                                <option value={item} key={idx}>
                                                    {item}
                                                </option>
                                            );
                                        })}
                                    {/* <option value="today">今天</option>
                                        <option value="tomorrow">明天</option> */}
                                </select>
                                <select
                                    name=""
                                    id="timeHour"
                                    ref={timeHour =>
                                        getChildRefs({
                                            name: 'timeHour',
                                            value: timeHour
                                        })
                                    }
                                    onChange={e => this.timeOnchange()}>
                                    {this.props.timeHour &&
                                        this.props.timeHour.map((item, idx) => {
                                            return (
                                                <option key={idx} value={item}>
                                                    {item}
                                                </option>
                                            );
                                        })}
                                </select>
                                时
                                <select
                                    name=""
                                    id="timeMinute"
                                    ref={timeMinute =>
                                        getChildRefs({
                                            name: 'timeMinute',
                                            value: timeMinute
                                        })
                                    }
                                    onChange={e => this.timeOnchange()}>
                                    {this.props.timeMinute &&
                                        this.props.timeMinute.map(
                                            (item, idx) => {
                                                return (
                                                    <option
                                                        key={idx}
                                                        value={item}>
                                                        {item}
                                                    </option>
                                                );
                                            }
                                        )}
                                </select>
                                分
                            </div>
                        </div>
                        <p>只能选择2-24小时范围内的时间</p>
                        <div className="timingBoxBottom">
                            <span onClick={e => this.closeCrop(e)}>取消</span>
                            <span onClick={e => this.getPublicTime(e)}>
                                确定
                            </span>
                        </div>
                    </div>
                    <div
                        className="timingBoxScreen"
                        onClick={e => this.closeCrop(e)}></div>
                </div>
                <div
                    className={classnames('previewBox', {
                        hide: previewBoxHasHide
                    })}>
                    <div className="preview-content-box">
                        <div className="preview-nav">
                            {['普通预览', '扫码预览'].map((item, idx) => {
                                return (
                                    <span
                                        onClick={() => this.previewSwitch(idx)}
                                        className={
                                            idx === previewActive
                                                ? 'active'
                                                : null
                                        }
                                        key={idx}>
                                        {item}
                                    </span>
                                );
                            })}
                        </div>
                        <span
                            className="previewCloseBtn"
                            onClick={e => this.closeCrop(e)}>
                            <img
                                src={require('../../assets/images/commonImg/whiteCloseBtn.png')}
                                alt=""
                            />
                        </span>
                        <div hidden={previewActive !== 0} className="phoneBox">
                            <div className="phoneBang"></div>
                            <div className="phoneConBox">
                                <div className="phoneBanner">
                                    <img src={cropImg} alt="" />
                                </div>
                                <div className="articleBox">
                                    <h3 className="phoneTitle">
                                        {articleTitle}
                                    </h3>
                                    <div className="articleTop">
                                        <div className="leftUserInfo">
                                            <div className="authorImg">
                                                {avatar && (
                                                    <img
                                                        src={avatar}
                                                        alt={userName}
                                                    />
                                                )}
                                            </div>
                                            <div className="nameTime">
                                                <div className="authorName">
                                                    {userName || '未知'}
                                                </div>
                                                <div className="phonePublicTime">
                                                    {moment().format(
                                                        'MM月DD日'
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="rightFollow">
                                            <span>+关注</span>
                                        </div> */}
                                    </div>
                                    <div className="phoneArticleIco"></div>
                                    <div
                                        className="phoneArticleCon"
                                        dangerouslySetInnerHTML={{
                                            __html: previewContent
                                        }}></div>
                                </div>

                                {/* <iframe style={{ width: '100%', height: '100%' }} id="dealIframe" name="dealIframe" width="100%" src={`${this.iframeAddr}/app/club/article/${sessionStorage.getItem('DRAFTID')}.html`} frameBorder="no" scrolling="yes"></iframe> */}
                            </div>
                            <div className="phoneMenu"></div>
                        </div>
                        <div
                            className="qrcode-box"
                            hidden={previewActive !== 1}>
                            <img src={articleQrcode} alt="" />
                        </div>
                    </div>
                    <div
                        className="previewBoxScreen"
                        onClick={e => this.closeCrop(e)}></div>
                </div>
                <div className={classnames('bigScreen', { hide: errorStatus })}>
                    <div className="errInfo">{errorContent}</div>
                </div>
                <div
                    className="itemEditorCon"
                    ref={itemEditorCon =>
                        getChildRefs({
                            name: 'itemEditorCon',
                            value: itemEditorCon
                        })
                    }></div>
            </div>
        );
    }
}
